import { initializeCard } from 'components/UserPaymentForm/utils';
import { useEffect, useState } from 'react';
import { useGetUserPaymentsQuery } from 'store/api/version-api.slice';

const useInitSquare = ({ onInitializeCard } = {}) => {
	const { data: userPaymentSettings = {}, isLoading } = useGetUserPaymentsQuery();

	const squareApplicationId = userPaymentSettings.SQ_APP_ID;
	const squareLocationId = userPaymentSettings.SQ_LOC_ID;

	const [cardErrors, setCardErrors] = useState();
	const [payments, setPayments] = useState();
	const [paymentMethod, setPaymentMethod] = useState();

	useEffect(() => {
		if (!isLoading) {
			setCardErrors(undefined);

			if (!window.Square) {
				console.warn('Square.js failed to load properly');
				return;
			}

			let _payments;

			try {
				_payments = window.Square.payments(squareApplicationId, squareLocationId);
				setPayments(_payments);
			} catch (e) {
				setCardErrors('Missing credentials: appId or locationId');

				console.error('Missing credentials: appId or locationId', e);
				return;
			}

			try {
				initializeCard(_payments).then(card => {
					onInitializeCard?.(card);
					setPaymentMethod(card);
				});
			} catch (e) {
				setCardErrors('Initializing Card failed');

				console.error('Initializing Card failed', e);
			}
		}
	}, [onInitializeCard, squareApplicationId, squareLocationId, isLoading]);

	// verificationToken can be undefined, as it does not apply to all payment methods.
	const createPayment = async ({ token, verificationToken, paymentHandler, paymentData }) => {
		const bodyParameters = {
			nonce: token,
			...paymentData
		};

		if (verificationToken !== undefined) {
			bodyParameters.verificationToken = verificationToken;
		}

		return paymentHandler(bodyParameters);
	};

	return {
		createPayment,
		cardErrors,
		payments,
		paymentMethod
	};
};

export default useInitSquare;
